import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination } from 'swiper';
import { useGlobalStore } from '../../../store/global';
import { useVariantsStore } from '../../../store/variants';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
export default function ProductImages({ product }) {
    const template_settings = useGlobalStore((state) => state.config.template_settings);
    const selectedVariant = useVariantsStore((state) => state.selectedVariant);
    const [swiper, setSwiper] = React.useState(null);
    const [imagesToRender, setImagesToRender] = React.useState(filerImages(template_settings.product_detail.gallery_with_image_variants.enabled, product, selectedVariant));
    const [selectedImage, setSelectedImage] = React.useState(0);
    React.useEffect(() => {
        if (swiper)
            swiper.slideTo(selectedImage);
    }, [selectedImage]);
    React.useEffect(() => {
        setImagesToRender(filerImages(template_settings.product_detail.gallery_with_image_variants.enabled, product, selectedVariant));
    }, [selectedVariant]);
    return (_jsxs("div", { className: "images d-flex", children: [imagesToRender.length > 0 && (_jsx(LeftThumbnails, { images: imagesToRender, selectedImage: selectedImage, setSelectedImage: (value) => setSelectedImage((prev) => (prev + value > 0 ? value : prev)) })), _jsx(Swiper, { className: "swiper-main", onSwiper: (swiper) => setSwiper(swiper), modules: [Navigation, Pagination], pagination: { clickable: true }, navigation: true, effect: "fade", slidesPerView: 1, speed: 800, onSlideChange: (swiper) => setSelectedImage(swiper.activeIndex), children: imagesToRender.map((image, i) => (_jsx(SwiperSlide, { children: _jsx("img", { src: image.url, alt: image.alt }) }, `image-${i}`))) })] }));
}
function LeftThumbnails({ images, selectedImage, setSelectedImage, }) {
    const [swiper, setSwiper] = React.useState(null);
    React.useEffect(() => {
        if (swiper)
            swiper.slideTo(selectedImage);
    }, [selectedImage]);
    return (_jsxs("div", { className: "flex-column d-md-flex d-none mr-2", children: [_jsx("button", { className: "btn-up", onClick: () => setSelectedImage(-1) }), _jsx(Swiper, { onSwiper: (swiper) => setSwiper(swiper), direction: 'vertical', className: "swiper-aside mt-2", slidesPerView: 'auto', effect: "fade", speed: 800, onSlideChange: (swiper) => setSelectedImage(swiper.activeIndex), children: images.map((image, i) => (_jsx(SwiperSlide, { className: `${selectedImage === i ? 'swiper-image-wrapper-selected' : 'swiper-image-wrapper'} ${i > 0 ? 'mt-1' : ''}`, onClick: () => {
                        if (swiper)
                            swiper.slideTo(i);
                        setSelectedImage(i);
                    }, children: _jsx("img", { src: image.url, alt: image.alt }) }, `thumbnail-${i}`))) }), _jsx("button", { className: "btn-down mt-2", onClick: () => setSelectedImage(1) })] }));
}
function filerImages(showOnlyVariantImages, product, selectedVariant) {
    if (showOnlyVariantImages && selectedVariant && selectedVariant.images.length > 0)
        return selectedVariant.images;
    return [product.image, ...product.images, ...product.variants.map((variant) => variant.images).flat()];
}
